
import React from 'react';
import './CustomModal.scss';

const Modal = ({ isPresales,show, handleClose, children, position }) => {
  return (
    <div className={`modal-image-overlay ${show ? 'show' : ''}`}>
      <div className={isPresales?"presales-modal-content":"allocation-modal-content"} style={{ alignItems:'center' ,justifyTracks:'center',alignContent:'center' }}>
        <span className="close" onClick={handleClose}>&times;</span>
        <div style={{height:"500px", width:"800px"}}>
        {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
